import styled, { theme } from 'academy-common-lib/utils/Styling';
export const ListVerticalRule = styled.span.withConfig({
  displayName: "ListVerticalRule",
  componentId: "hlyqgz-0"
})(["margin-right:5px;border-right:1px solid ", ";height:30px;position:relative;"], theme.colors.BATTLESHIP);